module.exports = __webpack_public_path__ + "media/images/ui__textArrowRightLight--dark-0cbc46363207e8906905f0ba56646660.png";